module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av363-2aa3d092d0ab53ea508d1a27c983b511.jpg";